export default "__VITE_ASSET__d0b7546c__"